export const saleMinPrices = {
    "en": [
        {
            value: '0',
            nom: 'Min Price'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        },
        {
            value: '1250000',
            nom: '1,250,000'
        },
        {
            value: '1500000',
            nom: '1,500,000'
        },
        {
            value: '1750000',
            nom: '1,750,000'
        },
        {
            value: '2000000',
            nom: '2,000,000'
        },
        {
            value: '2250000',
            nom: '2,250,000'
        },
        {
            value: '2500000',
            nom: '2,500,000'
        },
        {
            value: '2750000',
            nom: '2,750,000'
        },
        {
            value: '3000000',
            nom: '3,000,000'
        },
        {
            value: '3250000',
            nom: '3,250,000'
        },
        {
            value: '3500000',
            nom: '3,500,000'
        },
        {
            value: '3750000',
            nom: '3,750,000'
        },
        {
            value: '4000000',
            nom: '4,000,000'
        },
        {
            value: '4500000',
            nom: '4,500,000'
        },
        {
            value: '5000000',
            nom: '5,000,000'
        },
        {
            value: '5500000',
            nom: '5,500,000'
        },
        {
            value: '6000000',
            nom: '6,000,000'
        },
        {
            value: '6500000',
            nom: '6,500,000'
        },
        {
            value: '7000000',
            nom: '7,000,000'
        },
        {
            value: '8000000',
            nom: '8,000,000'
        },
        {
            value: '9000000',
            nom: '9,000,000'
        },
        {
            value: '10000000',
            nom: '10,000,000'
        },
        {
            value: '11000000',
            nom: '11,000,000'
        },
        {
            value: '12000000',
            nom: '12,000,000'
        },
        {
            value: '13000000',
            nom: '13,000,000'
        },
        {
            value: '15000000',
            nom: '15,000,000'
        },
        {
            value: '17500000',
            nom: '17,500,000'
        },
        {
            value: '20000000',
            nom: '20,000,000'
        },
        {
            value: '22500000',
            nom: '22,500,000'
        },
        {
            value: '25000000',
            nom: '25,000,000'
        },
        {
            value: '30000000',
            nom: '30,000,000'
        },
        {
            value: '35000000',
            nom: '35,000,000'
        },
        {
            value: '40000000',
            nom: '40,000,000'
        },
        {
            value: '60000000',
            nom: '60,000,000'
        },
        {
            value: '80000000',
            nom: '80,000,000'
        },
        {
            value: '100000000',
            nom: '100,000,000'
        },
        {
            value: '150000000',
            nom: '150,000,000'
        },
        {
            value: '200000000',
            nom: '200,000,000'
        },
        {
            value: '300000000',
            nom: '300,000,000'
        },
        {
            value: '500000000',
            nom: '500,000,000'
        }
    
    ],
    "th": [
        {
            value: '0',
            nom: 'ราคาขั้นต่ำ'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        },
        {
            value: '1250000',
            nom: '1,250,000'
        },
        {
            value: '1500000',
            nom: '1,500,000'
        },
        {
            value: '1750000',
            nom: '1,750,000'
        },
        {
            value: '2000000',
            nom: '2,000,000'
        },
        {
            value: '2250000',
            nom: '2,250,000'
        },
        {
            value: '2500000',
            nom: '2,500,000'
        },
        {
            value: '2750000',
            nom: '2,750,000'
        },
        {
            value: '3000000',
            nom: '3,000,000'
        },
        {
            value: '3250000',
            nom: '3,250,000'
        },
        {
            value: '3500000',
            nom: '3,500,000'
        },
        {
            value: '3750000',
            nom: '3,750,000'
        },
        {
            value: '4000000',
            nom: '4,000,000'
        },
        {
            value: '4500000',
            nom: '4,500,000'
        },
        {
            value: '5000000',
            nom: '5,000,000'
        },
        {
            value: '5500000',
            nom: '5,500,000'
        },
        {
            value: '6000000',
            nom: '6,000,000'
        },
        {
            value: '6500000',
            nom: '6,500,000'
        },
        {
            value: '7000000',
            nom: '7,000,000'
        },
        {
            value: '8000000',
            nom: '8,000,000'
        },
        {
            value: '9000000',
            nom: '9,000,000'
        },
        {
            value: '10000000',
            nom: '10,000,000'
        },
        {
            value: '11000000',
            nom: '11,000,000'
        },
        {
            value: '12000000',
            nom: '12,000,000'
        },
        {
            value: '13000000',
            nom: '13,000,000'
        },
        {
            value: '15000000',
            nom: '15,000,000'
        },
        {
            value: '17500000',
            nom: '17,500,000'
        },
        {
            value: '20000000',
            nom: '20,000,000'
        },
        {
            value: '22500000',
            nom: '22,500,000'
        },
        {
            value: '25000000',
            nom: '25,000,000'
        },
        {
            value: '30000000',
            nom: '30,000,000'
        },
        {
            value: '35000000',
            nom: '35,000,000'
        },
        {
            value: '40000000',
            nom: '40,000,000'
        },
        {
            value: '60000000',
            nom: '60,000,000'
        },
        {
            value: '80000000',
            nom: '80,000,000'
        },
        {
            value: '100000000',
            nom: '100,000,000'
        },
        {
            value: '150000000',
            nom: '150,000,000'
        },
        {
            value: '200000000',
            nom: '200,000,000'
        },
        {
            value: '300000000',
            nom: '300,000,000'
        },
        {
            value: '500000000',
            nom: '500,000,000'
        }
    
    ],
    "cn": [
        {
            value: '0',
            nom: '最低价格'
        },
        {
            value: '100000',
            nom: '100,000'
        },
        {
            value: '150000',
            nom: '150,000'
        },
        {
            value: '250000',
            nom: '250,000'
        },
        {
            value: '500000',
            nom: '500,000'
        },
        {
            value: '750000',
            nom: '750,000'
        },
        {
            value: '1000000',
            nom: '1,000,000'
        },
        {
            value: '1250000',
            nom: '1,250,000'
        },
        {
            value: '1500000',
            nom: '1,500,000'
        },
        {
            value: '1750000',
            nom: '1,750,000'
        },
        {
            value: '2000000',
            nom: '2,000,000'
        },
        {
            value: '2250000',
            nom: '2,250,000'
        },
        {
            value: '2500000',
            nom: '2,500,000'
        },
        {
            value: '2750000',
            nom: '2,750,000'
        },
        {
            value: '3000000',
            nom: '3,000,000'
        },
        {
            value: '3250000',
            nom: '3,250,000'
        },
        {
            value: '3500000',
            nom: '3,500,000'
        },
        {
            value: '3750000',
            nom: '3,750,000'
        },
        {
            value: '4000000',
            nom: '4,000,000'
        },
        {
            value: '4500000',
            nom: '4,500,000'
        },
        {
            value: '5000000',
            nom: '5,000,000'
        },
        {
            value: '5500000',
            nom: '5,500,000'
        },
        {
            value: '6000000',
            nom: '6,000,000'
        },
        {
            value: '6500000',
            nom: '6,500,000'
        },
        {
            value: '7000000',
            nom: '7,000,000'
        },
        {
            value: '8000000',
            nom: '8,000,000'
        },
        {
            value: '9000000',
            nom: '9,000,000'
        },
        {
            value: '10000000',
            nom: '10,000,000'
        },
        {
            value: '11000000',
            nom: '11,000,000'
        },
        {
            value: '12000000',
            nom: '12,000,000'
        },
        {
            value: '13000000',
            nom: '13,000,000'
        },
        {
            value: '15000000',
            nom: '15,000,000'
        },
        {
            value: '17500000',
            nom: '17,500,000'
        },
        {
            value: '20000000',
            nom: '20,000,000'
        },
        {
            value: '22500000',
            nom: '22,500,000'
        },
        {
            value: '25000000',
            nom: '25,000,000'
        },
        {
            value: '30000000',
            nom: '30,000,000'
        },
        {
            value: '35000000',
            nom: '35,000,000'
        },
        {
            value: '40000000',
            nom: '40,000,000'
        },
        {
            value: '60000000',
            nom: '60,000,000'
        },
        {
            value: '80000000',
            nom: '80,000,000'
        },
        {
            value: '100000000',
            nom: '100,000,000'
        },
        {
            value: '150000000',
            nom: '150,000,000'
        },
        {
            value: '200000000',
            nom: '200,000,000'
        },
        {
            value: '300000000',
            nom: '300,000,000'
        },
        {
            value: '500000000',
            nom: '500,000,000'
        }
    
    ],
    "ru": [
    {
        "value": "0",
        "nom": "Минимальная цена"
    },
    {
        "value": "100000",
        "nom": "100,000"
    },
    {
        "value": "150000",
        "nom": "150,000"
    },
    {
        "value": "250000",
        "nom": "250,000"
    },
    {
        "value": "500000",
        "nom": "500,000"
    },
    {
        "value": "750000",
        "nom": "750,000"
    },
    {
        "value": "1000000",
        "nom": "1,000,000"
    },
    {
        "value": "1250000",
        "nom": "1,250,000"
    },
    {
        "value": "1500000",
        "nom": "1,500,000"
    },
    {
        "value": "1750000",
        "nom": "1,750,000"
    },
    {
        "value": "2000000",
        "nom": "2,000,000"
    },
    {
        "value": "2250000",
        "nom": "2,250,000"
    },
    {
        "value": "2500000",
        "nom": "2,500,000"
    },
    {
        "value": "2750000",
        "nom": "2,750,000"
    },
    {
        "value": "3000000",
        "nom": "3,000,000"
    },
    {
        "value": "3250000",
        "nom": "3,250,000"
    },
    {
        "value": "3500000",
        "nom": "3,500,000"
    },
    {
        "value": "3750000",
        "nom": "3,750,000"
    },
    {
        "value": "4000000",
        "nom": "4,000,000"
    },
    {
        "value": "4500000",
        "nom": "4,500,000"
    },
    {
        "value": "5000000",
        "nom": "5,000,000"
    },
    {
        "value": "5500000",
        "nom": "5,500,000"
    },
    {
        "value": "6000000",
        "nom": "6,000,000"
    },
    {
        "value": "6500000",
        "nom": "6,500,000"
    },
    {
        "value": "7000000",
        "nom": "7,000,000"
    },
    {
        "value": "8000000",
        "nom": "8,000,000"
    },
    {
        "value": "9000000",
        "nom": "9,000,000"
    },
    {
        "value": "10000000",
        "nom": "10,000,000"
    },
    {
        "value": "11000000",
        "nom": "11,000,000"
    },
    {
        "value": "12000000",
        "nom": "12,000,000"
    },
    {
        "value": "13000000",
        "nom": "13,000,000"
    },
    {
        "value": "15000000",
        "nom": "15,000,000"
    },
    {
        "value": "17500000",
        "nom": "17,500,000"
    },
    {
        "value": "20000000",
        "nom": "20,000,000"
    },
    {
        "value": "22500000",
        "nom": "22,500,000"
    },
    {
        "value": "25000000",
        "nom": "25,000,000"
    },
    {
        "value": "30000000",
        "nom": "30,000,000"
    },
    {
        "value": "35000000",
        "nom": "35,000,000"
    },
    {
        "value": "40000000",
        "nom": "40,000,000"
    },
    {
        "value": "60000000",
        "nom": "60,000,000"
    },
    {
        "value": "80000000",
        "nom": "80,000,000"
    },
    {
        "value": "100000000",
        "nom": "100,000,000"
    },
    {
        "value": "150000000",
        "nom": "150,000,000"
    },
    {
        "value": "200000000",
        "nom": "200,000,000"
    },
    {
        "value": "300000000",
        "nom": "300,000,000"
    },
    {
        "value": "500000000",
        "nom": "500,000,000"
    }
    ],
    "de": [
    {
        "value": "0",
        "nom": "Mindestpreis"
    },
    {
        "value": "100000",
        "nom": "100,000"
    },
    {
        "value": "150000",
        "nom": "150,000"
    },
    {
        "value": "250000",
        "nom": "250,000"
    },
    {
        "value": "500000",
        "nom": "500,000"
    },
    {
        "value": "750000",
        "nom": "750,000"
    },
    {
        "value": "1000000",
        "nom": "1,000,000"
    },
    {
        "value": "1250000",
        "nom": "1,250,000"
    },
    {
        "value": "1500000",
        "nom": "1,500,000"
    },
    {
        "value": "1750000",
        "nom": "1,750,000"
    },
    {
        "value": "2000000",
        "nom": "2,000,000"
    },
    {
        "value": "2250000",
        "nom": "2,250,000"
    },
    {
        "value": "2500000",
        "nom": "2,500,000"
    },
    {
        "value": "2750000",
        "nom": "2,750,000"
    },
    {
        "value": "3000000",
        "nom": "3,000,000"
    },
    {
        "value": "3250000",
        "nom": "3,250,000"
    },
    {
        "value": "3500000",
        "nom": "3,500,000"
    },
    {
        "value": "3750000",
        "nom": "3,750,000"
    },
    {
        "value": "4000000",
        "nom": "4,000,000"
    },
    {
        "value": "4500000",
        "nom": "4,500,000"
    },
    {
        "value": "5000000",
        "nom": "5,000,000"
    },
    {
        "value": "5500000",
        "nom": "5,500,000"
    },
    {
        "value": "6000000",
        "nom": "6,000,000"
    },
    {
        "value": "6500000",
        "nom": "6,500,000"
    },
    {
        "value": "7000000",
        "nom": "7,000,000"
    },
    {
        "value": "8000000",
        "nom": "8,000,000"
    },
    {
        "value": "9000000",
        "nom": "9,000,000"
    },
    {
        "value": "10000000",
        "nom": "10,000,000"
    },
    {
        "value": "11000000",
        "nom": "11,000,000"
    },
    {
        "value": "12000000",
        "nom": "12,000,000"
    },
    {
        "value": "13000000",
        "nom": "13,000,000"
    },
    {
        "value": "15000000",
        "nom": "15,000,000"
    },
    {
        "value": "17500000",
        "nom": "17,500,000"
    },
    {
        "value": "20000000",
        "nom": "20,000,000"
    },
    {
        "value": "22500000",
        "nom": "22,500,000"
    },
    {
        "value": "25000000",
        "nom": "25,000,000"
    },
    {
        "value": "30000000",
        "nom": "30,000,000"
    },
    {
        "value": "35000000",
        "nom": "35,000,000"
    },
    {
        "value": "40000000",
        "nom": "40,000,000"
    },
    {
        "value": "60000000",
        "nom": "60,000,000"
    },
    {
        "value": "80000000",
        "nom": "80,000,000"
    },
    {
        "value": "100000000",
        "nom": "100,000,000"
    },
    {
        "value": "150000000",
        "nom": "150,000,000"
    },
    {
        "value": "200000000",
        "nom": "200,000,000"
    },
    {
        "value": "300000000",
        "nom": "300,000,000"
    },
    {
        "value": "500000000",
        "nom": "500,000,000"
    }
    ],
    "fr": [
    {
        "value": "0",
        "nom": "Prix minimum"
    },
    {
        "value": "100000",
        "nom": "100 000"
    },
    {
        "value": "150000",
        "nom": "150 000"
    },
    {
        "value": "250000",
        "nom": "250 000"
    },
    {
        "value": "500000",
        "nom": "500 000"
    },
    {
        "value": "750000",
        "nom": "750 000"
    },
    {
        "value": "1000000",
        "nom": "1 000 000"
    },
    {
        "value": "1250000",
        "nom": "1 250 000"
    },
    {
        "value": "1500000",
        "nom": "1 500 000"
    },
    {
        "value": "1750000",
        "nom": "1 750 000"
    },
    {
        "value": "2000000",
        "nom": "2 000 000"
    },
    {
        "value": "2250000",
        "nom": "2 250 000"
    },
    {
        "value": "2500000",
        "nom": "2 500 000"
    },
    {
        "value": "2750000",
        "nom": "2 750 000"
    },
    {
        "value": "3000000",
        "nom": "3 000 000"
    },
    {
        "value": "3250000",
        "nom": "3 250 000"
    },
    {
        "value": "3500000",
        "nom": "3 500 000"
    },
    {
        "value": "3750000",
        "nom": "3 750 000"
    },
    {
        "value": "4000000",
        "nom": "4 000 000"
    },
    {
        "value": "4500000",
        "nom": "4 500 000"
    },
    {
        "value": "5000000",
        "nom": "5 000 000"
    },
    {
        "value": "5500000",
        "nom": "5 500 000"
    },
    {
        "value": "6000000",
        "nom": "6 000 000"
    },
    {
        "value": "6500000",
        "nom": "6 500 000"
    },
    {
        "value": "7000000",
        "nom": "7 000 000"
    },
    {
        "value": "8000000",
        "nom": "8 000 000"
    },
    {
        "value": "9000000",
        "nom": "9 000 000"
    },
    {
        "value": "10000000",
        "nom": "10 000 000"
    },
    {
        "value": "11000000",
        "nom": "11 000 000"
    },
    {
        "value": "12000000",
        "nom": "12 000 000"
    },
    {
        "value": "13000000",
        "nom": "13 000 000"
    },
    {
        "value": "15000000",
        "nom": "15 000 000"
    },
    {
        "value": "17500000",
        "nom": "17 500 000"
    },
    {
        "value": "20000000",
        "nom": "20 000 000"
    },
    {
        "value": "22500000",
        "nom": "22 500 000"
    },
    {
        "value": "25000000",
        "nom": "25 000 000"
    },
    {
        "value": "30000000",
        "nom": "30 000 000"
    },
    {
        "value": "35000000",
        "nom": "35 000 000"
    },
    {
        "value": "40000000",
        "nom": "40 000 000"
    },
    {
        "value": "60000000",
        "nom": "60 000 000"
    },
    {
        "value": "80000000",
        "nom": "80 000 000"
    },
    {
        "value": "100000000",
        "nom": "100 000 000"
    },
    {
        "value": "150000000",
        "nom": "150 000 000"
    },
    {
        "value": "200000000",
        "nom": "200 000 000"
    },
    {
        "value": "300000000",
        "nom": "300 000 000"
    },
    {
        "value": "500000000",
        "nom": "500 000 000"
    }
]
}